/* ==========================================================================
   SOULGASM CELESTIAL CURSOR STAR TRAIL
   Emits sparkling stars in the signature rainbow gradient colors on mousemove
   ========================================================================== */

(function () {
  const gradientColors = [
    '#3E9B4F', // Green
    '#1F9E8F', // Teal
    '#2F73C8', // Blue
    '#5B45B8', // Indigo
    '#8E3AA8', // Purple
    '#C42F7A', // Magenta
    '#D9412F', // Red
    '#E07C22'  // Orange
  ];

  let lastX = 0;
  let lastY = 0;
  let lastTime = 0;

  function createStarParticle(x, y) {
    const star = document.createElement('div');
    star.className = 'cursor-star-particle';
    
    // Pick random gradient color
    const color = gradientColors[Math.floor(Math.random() * gradientColors.length)];
    
    // Random size & rotation
    const size = Math.floor(Math.random() * 12) + 8; // 8px - 20px
    const rotation = Math.floor(Math.random() * 360);
    const velocityX = (Math.random() - 0.5) * 30;
    const velocityY = (Math.random() - 0.5) * 30 - 15; // float slightly upwards

    star.style.left = `${x}px`;
    star.style.top = `${y}px`;
    star.style.width = `${size}px`;
    star.style.height = `${size}px`;
    star.style.setProperty('--star-color', color);
    star.style.setProperty('--vx', `${velocityX}px`);
    star.style.setProperty('--vy', `${velocityY}px`);
    star.style.setProperty('--rot', `${rotation}deg`);

    // 4-Point Star SVG Content
    star.innerHTML = `
      <svg viewBox="0 0 24 24" width="100%" height="100%">
        <path d="M12 0L14.5 9.5L24 12L14.5 14.5L12 24L9.5 14.5L0 12L9.5 9.5L12 0Z" fill="${color}" />
      </svg>
    `;

    document.body.appendChild(star);

    // Remove particle after animation completes
    setTimeout(() => {
      if (star && star.parentNode) {
        star.parentNode.removeChild(star);
      }
    }, 700);
  }

  document.addEventListener('mousemove', function (e) {
    const now = Date.now();
    // Throttle particle creation slightly (every 35ms or > 12px travel)
    const dist = Math.hypot(e.clientX - lastX, e.clientY - lastY);
    
    if (now - lastTime > 35 && dist > 10) {
      createStarParticle(e.clientX, e.clientY);
      lastX = e.clientX;
      lastY = e.clientY;
      lastTime = now;
    }
  });
})();
